import { render, staticRenderFns } from "./PhoneAddIcon.vue?vue&type=template&id=ad28f5e0&"
import script from "./PhoneAddIcon.vue?vue&type=script&lang=ts&"
export * from "./PhoneAddIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports